/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SkillCategoryRow_skills = ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"SkillRow_skill">;
    readonly " $refType": "SkillCategoryRow_skills";
}>;
export type SkillCategoryRow_skills$data = SkillCategoryRow_skills;
export type SkillCategoryRow_skills$key = ReadonlyArray<{
    readonly " $data"?: SkillCategoryRow_skills$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SkillCategoryRow_skills">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SkillCategoryRow_skills",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SkillRow_skill"
    }
  ],
  "type": "Skill"
};
(node as any).hash = 'db345436be00c622fa3776298ced3ab4';
export default node;
